import { writable } from './localStorageStore'

export const recentMemes = writable('recentMemes', [])
